module.exports = __webpack_public_path__ + "img/app8.0ea4a1d0.png";